import { extractZoneData, invalid_set } from "./PersonalDataProcess"
import { getDecimalData } from "./utilFuncs"

const labelAreaIndex = (distance, angle) => {
  let idx = -1
  if (angle > 135 || angle < 45) return idx
  if (distance > 180) {
    idx = Math.min(Math.floor((135-angle)/15), 5)
  } else {
    idx = Math.min(Math.floor((135-angle)/18) + 6, 10)
  }
  return idx
}
const calculateLocationPortions = (data) => {
  let original = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
  let count = 0
  for (const i of data) {
    let index = labelAreaIndex(parseFloat(i.ExitDistance), parseFloat(i.Theta))
    if (index !== -1) {
      original[index]++
      count++
    }
  }
  return original.map((e) => (Math.round(e*100*10/count)/10))
}

const extractPitchUsageData = (data, target) => {
  // console.log(data, target)
  let pitchTypeSet = new Set()
  let output = { left: {}, right: {} }

  let count = { left: 0, right: 0 }
  // console.log(data)
  for (let p of data) {
    if (['', 'UN', '?', null].includes(p.TaggedPitchType)) continue
    let side = parseInt(p[target]) === 1 ? 'left' : 'right'
    let typetag = p.TaggedPitchType
    if (typetag === 'CT') typetag = 'SL'
    if (typetag === 'FT') typetag = 'FB'
    if (typetag === 'SFF') typetag = 'SP'
    pitchTypeSet.add(typetag)
    if (output[side][typetag] === undefined) output[side][typetag] = []
    if (!(invalid_set.includes(p.APP_KZoneY) && invalid_set.includes(p.APP_KZoneZ))) {
      output[side][typetag].push({ x: p.APP_KZoneY, y: p.APP_KZoneZ })
    }
    count[side]++
  }

  let usage = { left: [], right: [], all: [] }

  for (const s in output) {
    for (const t in output[s]) {
      if (parseFloat(getDecimalData(output[s][t].length * 100, count[s], 0)) < 0) continue
      usage[s].push({ tag: t, usage: getDecimalData(output[s][t].length * 100, count[s], 1) })
    }
  }

  pitchTypeSet = Array.from(pitchTypeSet)

  // console.log(output)

  const total = count.left + count.right
  for (const t of pitchTypeSet) {
    let left_count = output.left[t]? output.left[t].length:0
    let right_count = output.right[t]? output.right[t].length:0
    if (parseFloat(getDecimalData((left_count+right_count) * 100, total, 0)) < 0) continue
    usage.all.push({ tag: t, usage: getDecimalData((left_count+right_count) * 100, total, 1) })
  }
  // console.log(output)
  return { zone: output, usage, pitchTypeSet }
}

const extractDensityData = (data) => {
  let output = []
  for (const d of data) {
    if (d.PitchCode === 'Strk-S') {
      output.push({x: parseFloat(d.APP_KZoneY), y: parseFloat(d.APP_KZoneZ)})
    }
  }
  return output
}

export const resolveBatterLiveCardData = (data) => {
  const zoneData = extractZoneData(data, 'batter')
  const locationData = calculateLocationPortions(data.filter((e) => (['In-Play', 'Inplay'].includes(e.PitchCode))))
  const densityData = extractDensityData(data)

  return { zoneData, locationData, densityData }
}

export const resolvePitcherLiveCardData = (data) => {
  const zoneData = extractZoneData(data, 'pitcher')
  const usageData = extractPitchUsageData(data, 'BatS')
  const densityData = extractDensityData(data)

  return { zoneData, usageData, densityData }
}